
import { supabase } from './client';

/**
 * Creates stored procedures in Supabase for more reliable attendance updates
 */
export const createStoredProcedures = async () => {
  console.log('Setting up stored procedures...');
  
  try {
    // Create a function to confirm attendance that ensures atomic updates
    const { error } = await supabase.rpc('create_confirm_attendance_function');
    
    if (error) {
      // If the function already exists, try creating it directly
      console.log('Creating confirm_attendance function directly...');
      const { error: directError } = await supabase.rpc('confirm_attendance_exists');
      
      if (!directError) {
        console.log('confirm_attendance function already exists');
        return true;
      }
      
      // If it still fails, create it with raw SQL via a special endpoint
      console.log('Creating function through admin API...');
      const { error: createError } = await supabase
        .from('system_functions')
        .insert({
          function_name: 'confirm_attendance',
          function_definition: `
            CREATE OR REPLACE FUNCTION confirm_attendance(attendee_code text, check_in_time timestamptz)
            RETURNS json
            LANGUAGE plpgsql
            AS $$
            DECLARE
              result json;
            BEGIN
              -- Update the attendee record
              UPDATE attendees
              SET attended = true, checked_in_at = check_in_time
              WHERE code = attendee_code;
              
              -- Return success
              SELECT json_build_object('success', true, 'code', attendee_code) INTO result;
              RETURN result;
            END;
            $$;
          `
        });
        
      if (createError) {
        console.error('Failed to create function via admin API:', createError);
        return false;
      }
    }
    
    console.log('Stored procedures set up successfully');
    return true;
  } catch (error) {
    console.error('Error setting up stored procedures:', error);
    return false;
  }
};
